import { Button } from '@mui/material';
import React, { ElementType, FC } from 'react';

import { CustomButtonProps } from '../types';

export const TransparentButton: FC<CustomButtonProps> = (props) => {
	const { href, onClick, name, 'data-cy': dataCy, rel, target, disabled, theme, ...rest } = props;

	const Component: ElementType = href ? 'a' : 'button'; // Dynamically set the component

	return (
		<Button
			component={Component}
			href={href}
			className='transparent-button'
			style={{
				backgroundColor: 'transparent',
				border: 'none',
				color: theme.text.color,
				textTransform: 'none',
			}}
			data-cy={dataCy}
			onClick={onClick}
			rel={href ? rel : undefined}
			target={href ? target : undefined}
			disabled={disabled}
			{...rest}
		>
			{name}
		</Button>
	);
};
